import type { TFunction } from 'i18next';

export const TimeseriesAggregationType = {
	none: 'none',
	hourly: 'hourly',
	daily: 'daily',
	monthly: 'monthly',
};
export type TimeseriesAggregationType = keyof typeof TimeseriesAggregationType;

export const timeseriesAggregationTypeLabels = (t: TFunction): Record<TimeseriesAggregationType, string> => ({
	none: t('health.aggregation.none'),
	hourly: t('health.aggregation.hour'),
	daily: t('health.aggregation.day'),
	monthly: t('health.aggregation.month'),
});
export const timeseriesAggregationTypeLabelsArray = (t: TFunction) =>
	Object.entries(timeseriesAggregationTypeLabels(t)).map(([value, label]) => ({
		value: value as TimeseriesAggregationType,
		label,
	}));
